<template>
  <div class="modal" :class="{ 'modal--instagram': isExternalImage(modalImage) }" @click.stop="hideModal($event)" tabindex="0">
    <div class="modal__inner">
      <i class="modal__icon modal__icon--previous" @click.stop="showPrevious()" v-if="!item.hideNavigation"></i>
      <i class="modal__icon modal__icon--next" @click.stop="showNext()" v-if="!item.hideNavigation"></i>
      <i class="modal__icon modal__icon--close" @click.stop="hideModal()"></i>
      <div class="modal__content">
        <div class="modal__image">
          <figure>
            <img :src="imagePath(modalImage)">
          </figure>
        </div>
        <div class="modal__text">
          <header>
            <h2 v-show="!isExternalImage(modalImage)">{{ item.name }}</h2>
            <img :src="imagePath(item.profile)">
            <h3 v-html="item.description"></h3>
          </header>
          <article>
            <h4 v-show="!isExternalImage(modalImage)">Story</h4>
            <p v-html="item.story"></p>
            <a  v-show="isExternalImage(modalImage)" :href="item.link">Auf Instagram anzeigen »</a>
          </article>
        </div>
      </div>
      <ul v-if="item.items" class="modal__gallery">
        <li v-for="(image, index) in item.items" @click="setActiveImage(image, index)" :class="{ 'active': activeImage === index }">
          <figure>
            <img :src="imagePath(image.image)">
          </figure>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus.js'

export default {
  props: ['item'],
  data () {
    return {
      activeImage: 0,
      modalImage: this.item.image
    }
  },
  methods: {
    imagePath (image) {
      if (!image) {
        return
      }
      let path = this.isExternalImage(image) ? image : require('@/assets/' + image)
      return path
    },
    isExternalImage (imageUrl) {
      if (!imageUrl) {
        return
      }
      return imageUrl.indexOf('http') === 0
    },
    hideModal (event) {
      if (event && event.target.className !== 'modal') {
        return
      }
      this.activeImage = 0
      this.modalImage = this.item.image
      this.$emit('hide', null)
      document.querySelector('body').style.overflow = null
      EventBus.$emit('showModal', false)
    },
    setActiveImage (image, index) {
      this.activeImage = index
      this.modalImage = image.image
    },
    showPrevious () {
      EventBus.$emit('showPrevious', this.$el.closest('.instafeed'))
    },
    showNext () {
      EventBus.$emit('showNext', this.$el.closest('.instafeed'))
    },
    escapeKeyListener (event) {
      if (event.keyCode === 27) {
        this.hideModal()
      }
    },
    leftKeyListener (event) {
      if (event.keyCode === 37) {
        this.showPrevious()
      }
    },
    rightKeyListener (event) {
      if (event.keyCode === 39) {
        this.showNext()
      }
    }
  },
  mounted () {
    let el = this.$el
    /* eslint-disable no-undef */
    let observer = new WebKitMutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        let name = mutation.attributeName
        let newValue = mutation.target.getAttribute(name)
        if (name === 'style' && !newValue) {
          el.focus()
        }
      })
    })
    observer.observe(el, { attributes: true, subtree: false })
    el.addEventListener('mouseover', el.focus())
    el.addEventListener('keyup', this.leftKeyListener)
    el.addEventListener('keyup', this.rightKeyListener)
  },
  created () {
    window.addEventListener('keyup', this.escapeKeyListener)
    if (this.item.items) {
      this.item.items = [{name: this.item.name, image: this.item.image}, ...this.item.items]
    }
  },
  destroyed () {
    window.removeEventListener('keyup', this.escapeKeyListener)
    window.removeEventListener('keyup', this.leftKeyListener)
    window.removeEventListener('keyup', this.rightKeyListener)
  }
}
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: rgba(255, 255, 255, .8);

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 30px solid black;
  }

  &__inner {
    box-shadow: 0 0 30px rgba(0,0,0,0.2);
    background: white;
    z-index: 100;
    height: 80vh;
    width: 80vw;
    max-height: 710px;
    position: relative;
    max-width: 1420px;
    display: inherit;
  }

  &__content {
    display: flex;
  }

  &__icon {
    position: absolute;
    width: 50px;
    height: 50px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;

    &--close {
      width: 27px;
      top: 0;
      right: 0;
      transform: translateX(50%) translateY(-50%);
      background-image: url('/static/icon-close.svg');
    }

    &--previous, &--next {
      align-self: center;
    }
    &--previous {
      transform: translateX(-280px);
      left: 0;
      background-image: url('/static/icon-arrow-left.svg');
    }

    &--next {
      transform: translateX(280px);
      right: 0;
      background-image: url('/static/icon-arrow-right.svg');
    }
  }

  &__text {
    padding: 80px 75px;
    flex: 1;

    h2, h3 {
      text-transform: uppercase;
      letter-spacing: 8px;
    }

    h2 {
      font-weight: 700;
      font-size: 32px;
      margin: 0;
    }

    h3 {
      margin-top: 12px;
      font-weight: 400;
      font-size: 11.5px;
      line-height: 1.5;
      letter-spacing: 4px;
      color: #a4a4a4;
      transform: translateX(140px);
    }

    article {
      font-weight: 300;
      font-size: 28px;
      line-height: 1.607;
      transform: translateX(140px);
      margin-right: -60px;

      h4 {
        font-family: 'CorporateS', sans-serif;
        font-style: italic;
        font-weight: 400;
        font-size: 38.4px;
        position: relative;
        display: inline-block;
        margin-bottom: 20px;
        transform: rotate(-15deg) translateX(-55px);

        &:after {
          height: 3px;
          width: 100%;
          background: black;
          content: '';
          position: absolute;
          bottom: 6px;
          left: 0;
          margin-bottom: 5px;
        }

      }

      p {
        margin: 0;
        letter-spacing: 3.3px;
      }
    }
  }

  &__gallery {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left: calc((710px/2) - (118px / 2));
    bottom: 0;
    transform: translateY(50%);

    li {
      width: 118px;
      height: 118px;
      border: 5px solid transparent;
      cursor: pointer;

      &.active {
        border: 5px solid black;
      }

      + li {
        margin-left: 25px;
      }
    }

    figure {
      margin: 0;


      img {
        width: 100%;
      }
    }
  }

  &__image {
    margin: 0;
    max-height: 100%;

    figure {
      margin: 0;
      max-height: 100%;
    }

    img {
      width: auto;
      height: 80vh;
      max-height: 710px;
      max-width: 710px;
    }
  }
}

.modal--instagram {

  .modal__text {
    padding: 70px 65px;
    display: flex;
    flex-direction: column;

    article {
      margin: 0;
      transform: none;
    }

    article {
      font-size: 15px;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      height: 100%;

      p {
        letter-spacing: 0px;
        flex: 1;
      }

      a {
        align-self: flex-end;
        font-size: 16px;
      }
    }
  }

  .modal__image img {
    width: 830px;
    max-width: 830px;
  }

  header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    h3 {
      transform: none;
    }

    img {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      margin-right: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?93268a4e